module.exports = __webpack_public_path__ + "img/財富_四方連續_彩稿.53cfb41c.png";